import { useSnackbarContext } from './context'

export const useSnackbar = () => {
  const context = useSnackbarContext()

  return context
}
